export class EnumDescription {
    static GetDescription(enumTypeName: any, id: number): string {
        return enumTypeName[enumTypeName[id].toString() + 'Description'];
    }
}